import { render, staticRenderFns } from "./PlayDonut.vue?vue&type=template&id=0f8087ba&scoped=true"
import script from "./PlayDonut.vue?vue&type=script&lang=js"
export * from "./PlayDonut.vue?vue&type=script&lang=js"
import style0 from "./PlayDonut.vue?vue&type=style&index=0&id=0f8087ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8087ba",
  null
  
)

export default component.exports